<template>
    <div id="app">
        <AppHeader :sections="sections" @navigate="handleNavigate" />

        <HomeSection id="home" />
        <AboutSection id="about" />
        <ProjectsSection id="projects" />
        <ContactSection id="contact" />

       

        <footer class="site-footer">
            <div class="footer-content">
                <p>© 2023 上海泓域文化传媒有限公司 版权所有</p>
                <p>
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                        沪ICP备2024088698号
                    </a>
                </p>
                <p>
                    <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002007374" target="_blank" rel="noopener noreferrer">
                        <img src="./assets/JingHui.png" alt="警徽图标" style="vertical-align: middle; height: 16px;">
                        沪公网安备31011002007374号
                    </a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import HomeSection from './components/HomeSection.vue'
import AboutSection from './components/AboutSection.vue'
import ProjectsSection from './components/ProjectsSection.vue'
import ContactSection from './components/ContactSection.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    HomeSection,
    AboutSection,
    ProjectsSection,
    ContactSection
  },
  data() {
    return {
      sections: [
        { id: 'home', title: '首页' },
        { id: 'about', title: '公司简介' },
        { id: 'projects', title: '项目案例' },
        { id: 'contact', title: '联系我们' }
      ]
    }
  },
        methods: {
            handleNavigate(sectionId) {
                const element = document.getElementById(sectionId);
                if (!element) return;

                // 判断是否是“首页”
                if (sectionId === 'home') {
                    const navbarHeight = 80; // 根据你的导航栏高度调整
                    window.scrollTo({
                        top: element.offsetTop - navbarHeight,
                        behavior: 'smooth'
                    });
                } else {
                    // 其他页面区块：直接平滑滚动到顶部
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
}
</script>

<style>
/* 全局样式 */
body {
  margin: 0;
  font-family: 'Microsoft YaHei', sans-serif;
  color: #333;
}

.site-footer {
  background-color: #333;
  color: white;
  padding: 20px 0;
  text-align: center;
}
    .site-footer a {
        color: white;
        text-decoration: none; /* 可选：去除下划线 */
    }

        .site-footer a:hover {
            text-decoration: underline; /* 可选：鼠标悬停时显示下划线 */
        }
.footer-content p {
  margin: 5px 0;
}
</style>